import { Link } from "react-router-dom";
import { categories } from "@/mocks/events";

export default function Categories() {
  const list = categories.filter((c) => c.key !== "all");

  return (
    <section className="container-x py-12 md:py-16">
      <div className="mx-auto max-w-2xl text-center">
        <span className="inline-flex items-center gap-1.5 text-sm font-medium text-secondary-600">
          <i className="ri-folder-5-line"></i>
          内容分类
        </span>
        <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          按栏目快速吃瓜
        </h2>
        <p className="mt-3 text-sm text-foreground-600">
          覆盖明星、八卦、综艺、红人与社会热点，总有一个栏目满足你的好奇心。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
        {list.map((cat) => (
          <Link
            key={cat.key}
            to={`/events?cat=${cat.key}`}
            className="card group flex flex-col items-center p-5 text-center transition-colors hover:border-primary-300 hover:bg-background-100/60"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={cat.icon}></i>
            </span>
            <h3 className="mt-3 text-sm font-semibold text-foreground-900 group-hover:text-primary-700">
              {cat.label}
            </h3>
            <p className="mt-1 line-clamp-2 text-xs leading-5 text-foreground-500">{cat.desc}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}